import {utilHelper} from "../../_helpers";
import {
    LB_NOTIFICATION_ADDED,
    LB_NOTIFICATION_DELETED,
    SUCCESSFUL_TRANSLATION_LABEL
} from "../../../components/i18n/i18n";

const relativeUrl = 'api/activity'

export const activityService = {
    getItem,
    search,
    saveItem,
    updateItem,
    deleteItem,
    translate,
    getOptions,
    searchMapView,
    show,
    notify,
    index,
    sync
};

function sync(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/sync`, 'POST', { data, showAlert: false })
}

//getOptions
function getOptions(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function getItem(id, fbDataBase) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDataBase}`, 'GET', {showAlert:false})
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id, db) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${db}`, 'DELETE', { })
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

function searchMapView(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/searchMapView`, 'POST', { data: data, showAlert : false })
}

function show(id, db) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${db}`, 'GET', { showAlert: false })
}



function notify(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/send`, 'POST', { data, message:'Notificación Exitosa' });
}

function index(){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/`, 'GET', { message:'Descargando' });
}